const itemType = {
    CARD:"card"
}

export default itemType;